interface StatusBadgeProps {
  status: 'critical' | 'warning' | 'normal' | 'unknown' | 'blocked'
  label?: string
  size?: 'sm' | 'md'
}

const statusStyles: Record<StatusBadgeProps['status'], string> = {
  critical: 'bg-status-critical text-white',
  warning: 'bg-status-warning text-black',
  normal: 'bg-status-normal text-white',
  unknown: 'bg-status-unknown text-white',
  blocked: 'bg-status-blocked text-white',
}

const dotStyles: Record<StatusBadgeProps['status'], string> = {
  critical: 'bg-status-critical',
  warning: 'bg-status-warning',
  normal: 'bg-status-normal',
  unknown: 'bg-status-unknown',
  blocked: 'bg-status-blocked',
}

export function StatusBadge({ status, label, size = 'sm' }: StatusBadgeProps) {
  const dot = size === 'sm' ? 'w-1.5 h-1.5' : 'w-2 h-2'
  const text = size === 'sm' ? 'text-[10px]' : 'text-xs'
  const pad = size === 'sm' ? 'px-1.5 py-0.5' : 'px-2 py-1'

  return (
    <span className={`inline-flex items-center gap-1.5 rounded-sm ${statusStyles[status]} ${text} ${pad}`}>
      <span className={`${dot} rounded-full ${dotStyles[status]}`} />
      {label || status}
    </span>
  )
}
